import React, { useEffect, useRef } from 'react';
import Input from '../InputForm';
import { useHistory } from 'react-router';
import { vaccinationApiRequestBody } from '../../Utils/vaccinationApiRequestBody'
import lodash from 'lodash';
import config from '../../../../../config.json'
import './thankYou.css';
import apiRequest from "../../../../../utils/api.request";

const capture_interest_whatsapp_url = config.covid_vacc_base_url + "v1/set-whatsapp-consent/";

const Thankyou = ({ message, jhhId, _handleCancelClick, profileDetails, t, closeWindowOnThankYouDone=false }) => {
  const history = useHistory();
  const urlParams = new URLSearchParams(window.location.search);
  const thank_you_ref = useRef();
  const [whatsappNotifiaction, _setWhatsappNotification] = React.useState(false);

  useEffect(() => {
    thank_you_ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, [])

  const _handleDoneClick = async () => {
    let dataObj = {
      "jhh_id": jhhId,
      "consent_value": whatsappNotifiaction ? "yes" : "no"
    }
    dataObj = vaccinationApiRequestBody(dataObj, profileDetails);
    const response = await apiRequest(capture_interest_whatsapp_url, dataObj, true);

    if (lodash.get(response, "status") !== "success") {
      return;
    }

    if(closeWindowOnThankYouDone) {
      window.close();
    } else {
      history.push(`/vaccination-details?${urlParams.toString()}`);
    }
  }

  return (
    <div ref={thank_you_ref} className="express-interest-question">
      <div className="express-interest-left-col">
      </div>
      <div className="express-interest-right-col">
        <p className="express-interest-question-description">
          {message} {t("EOI_THANK_YOU_COMPONENT_TEXT")} <span className="express-interest-question-description-bold">{t("VACCINATION_PORTAL_ACCESS_MESSAGE")}</span>
        </p>
        <div className="express-interest-whatsapp-div">
          <div>
            <input id="express-interest-thank-you-checkbox" type="checkbox" checked={whatsappNotifiaction} onChange={() => _setWhatsappNotification(!whatsappNotifiaction)}></input>
          </div>
          <label htmlFor="express-interest-thank-you-checkbox" className="express-interest-whatsapp-text">
            {t("EOI_THANK_YOU_COMPONENT_WHATSAPP_NOTIFICATION_TEXT")}
          </label>
        </div>
        <div className="express-interest-modal-buttons">
          <Input
            addClassInput="express-interest-modal-button-no express-interest-modal-button-padding"
            type="button"
            value={t("EOI_CANCEL")}
            onClick={_handleCancelClick}
          />
          <Input
            addClassInput="express-interest-modal-button-yes express-interest-modal-button-padding"
            type="button"
            value={t("EOI_DONE")}
            onClick={_handleDoneClick}
          />
        </div>
      </div>
    </div>
  );
};

export default Thankyou;